export default [
  {
    meta: { requireSignin: false },
    name: 'error/404',
    path: '*',
    component: () => import('@/pages/error/error404.vue'),
  },
  {
    meta: { requireSignin: false },
    name: 'error/500',
    path: '/error/500',
    component: () => import('@/pages/error/error500.vue'),
  },
  {
    meta: { requireSignin: false },
    name: 'maintenance',
    path: '/maintenance',
    component: () => import('@/pages/error/Maintenance.vue'),
  },
]
